import React from 'react';
import { useCountUp } from '../hooks/useCountUp';

const styles = {
  cell: {
    background: '#fff',
    padding: '24px 20px',
    display: 'flex',
    flexDirection: 'column',
  },
  val: {
    fontFamily: 'var(--serif)',
    fontSize: 32,
    color: 'var(--g2)',
    lineHeight: 1,
    marginBottom: 6,
    fontWeight: 600,
  },
  lbl: { fontSize: 12, fontWeight: 600, color: 'var(--ink)', marginBottom: 2 },
  sub: { fontSize: 11, color: 'var(--gray)' },
};

export default function StatCard({ value, format, prefix = '', suffix = '', label, sub, trigger }) {
  const display = useCountUp(value, format, prefix, suffix, trigger);
  return (
    <div className="r25-stat-cell" style={styles.cell}>
      <div className="r25-stat-val" style={styles.val}>{display}</div>
      <div style={styles.lbl}>{label}</div>
      {sub && <div style={styles.sub}>{sub}</div>}
    </div>
  );
}
